module.exports = __webpack_public_path__ + "img/frame (137).dacc60f0.jpg";